import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: theme.typography.caption.fontSize,
    color: theme.palette.darkGrey.light,
    marginBottom: theme.spacing(1),
    display: 'block',
  },
  error: {
    color: theme.palette.red.main,
  },
  success: {
    color: theme.palette.green.main,
  },
}));

const Label = (props) => {
  const classes = useStyles();
  const {
    label, inputId, required, error, success,
  } = props;
  return !!label && (
    <Typography
      component="label"
      variant="body1"
      htmlFor={inputId}
      className={clsx(classes.root,
        (error && classes.error), (!error && success && classes.success))}
    >
      {required ? `${label}*` : label}
    </Typography>
  );
};

Label.propTypes = {
  label: PropTypes.string.isRequired,
  inputId: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.bool,
  success: PropTypes.bool,
};

Label.defaultProps = {
  inputId: undefined,
  required: false,
  error: false,
  success: false,
};

export default Label;
